import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { Table } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';

import mixin from '../../../utils/mixin.js';

import { getAgentsByUser } from '../../../api/Api.js';

import './Agents.scss';

import AgentForm from '../AgentForm/AgentForm.js';

import NavbarMenu from '../NavbarMenu/NavbarMenu.js';

const {methods} = mixin;

class Agents extends Component {

  constructor(props){
    
    super(props);

    let dev = localStorage.getItem('dev');
    if(dev == null || dev == undefined || dev == ''){
      this.props.history.push("/admin");
      window.location.reload();
    }

    dev = JSON.parse(dev);

    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }

    methods.G_changeLanguage('es');

    this.state = {
      loading: false,
      users: [],
      selected_user: null,
      action: null,
      development_id: dev.development_id,
      development: dev,
    }
  }

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  addUser = () => {
    this.setState({
      action: 'add',
      selected_user: null
    })
  }

  editUser = (user) => {
    if (user != null && user != undefined) {
      this.setState({
        action: 'update',
        selected_user: user
      })
    }
  }

  updateDeletedUser = (agent_id) => {
    let index = this.state.users.findIndex((item) => agent_id == item['agent_id']);
    let users = [...this.state.users]
    if(index >= 0){
      users.splice(index, 1)
      this.setState({
        users: users,
        action: 'add',
        selected_user: null
      });
    }
  }

  showUsersList = () => {
    this.setState({
      action: null,
      selected_user: null
    })
  }

  dispatchUsers = () => new Promise((resolve, reject) => {
    // const { developmentId } = this.state
    const user = JSON.parse(localStorage.getItem('user'));
    getAgentsByUser({
      user_id: user.user_id
    }).then((res) => {
      let users = [];
      if (res) {
        users = res;
      }
      this.setState({
        users: users ,
      }, () => resolve('users data ok'));
    });
  });

  addNewUser = (user) => {
    this.setState({
      users: [...this.state.users, user]
    });
  }

  updateUser = (user) => {
    let index = this.state.users.findIndex((item) =>user['agent_id'] == item['agent_id']);
    let users = [...this.state.users]
    if(index >= 0){
      users[index] = user;
      this.setState({
        users: users
      });
    }
  }

  componentDidMount() {
    
    this.setState({
      loading: true
    }, () => {
      Promise.all([this.dispatchUsers()]).then(values => {
        
        this.setState({
            loading: false,
            action: 'add'
        });

      }, reason => {
          console.info(reason)
      });
    });
  }

  renderUserTypeLabel = (type) => {
    switch(type){
      case 1: return 'Súper Administrador';
      case 2: return 'Opearaciones';
      case 3: return 'Administrador';
      case 4: return 'Vendedor';
      case 6: return 'Inmobiliaria';
    }
  }

  renderUsersTable = () => {
    let users = (this.state.users && this.state.users.length > 0) ? [...this.state.users] : [];

    const listUsers = users ? users.map((i) => {
      return( 
        <tr onClick={this.editUser.bind(this, i)}  className="user-item" key={i.agent_id}>
          <td>{i.first_name}</td>
          <td>{i.last_name}</td>
          <td>{i.last_name_2}</td>
          <td>{i.email}</td>
        </tr>
      )
    }) : [];

    if(listUsers.length > 0){
      return (
        <Table responsive striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Apellido Paterno</th>
              <th>Apellido Materno</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {listUsers}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay ningún vendedor configurado.</span>
      );
    }

  }

  render() {
      const { users, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-6 pt-4 pb-5 pr-4 left-panel">
                <div>
                  <h3>Vendedores</h3>
                  <button className="btn btn-cust-blue btn-add-agent" onClick={this.addUser.bind(this)}>Agregar Vendedor</button>
                  <br/><br/>
                  {this.renderUsersTable()}
                </div>
              </div>
              <div className="col-12 col-md-6 pt-4 pb-5 pl-4 right-panel">
                {
                  this.state.action == 'add' &&
                  this.state.selected_user == null &&
                  < AgentForm action={this.state.action} close={this.showUsersList} user={null} agent_id="" development_id={this.state.development_id} add={this.addNewUser} />
                }
                {
                  this.state.action == 'update' &&
                  this.state.selected_user != null &&
                  < AgentForm action={this.state.action} close={this.showUsersList} user={this.state.selected_user} agent_id={this.state.selected_user['agent_id']} development_id={this.state.development_id} update={this.updateUser} update_deleted={this.updateDeletedUser} />
                }
              </div>
              
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(Agents);